import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Button,
  Grid,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { fetchOrders, setOrder, setOrderBy, setTabValue } from "../../redux/actions/DashboardActions";
import { fetchTagSuggestions } from "../../redux/actions/orderActions";
import OrderList from "../table/OrderList";

const OrderLists = ({ limit = 10 }) => {
  const dispatch = useDispatch();
  const { orders, loading, tabValue, orderBy, order } = useSelector(
    (state) => state.orders
  );
  const dealerLogin = useSelector((state) => state.dealerLogin);
  const { dealerInfo } = dealerLogin;
  const { tagOptions } = useSelector((state) => state.ordertags);

  const [tag, setTag] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (dealerInfo?._id) {
      dispatch(
        fetchOrders(
          {
            page,
            limit,
            status: tabValue,
            tag,
            dealerId: dealerInfo._id,
          },
          dealerInfo.token
        )
      );
    }
  }, [tabValue, orderBy, order, dealerInfo, dispatch, tag, page, limit]);

  useEffect(() => {
    if (dealerInfo?._id && tag) {
      dispatch(fetchTagSuggestions(tag, dealerInfo._id, dealerInfo.token));
    }
  }, [tag, dealerInfo, dispatch]);

  const handleTabChange = (event, newValue) => {
    dispatch(setTabValue(newValue));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    dispatch(setOrder(isAsc ? "desc" : "asc"));
    dispatch(setOrderBy(property));
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    dispatch(
      fetchOrders(
        {
          page: newPage,
          limit,
          status: tabValue,
          tag,
          dealerId: dealerInfo._id,
        },
        dealerInfo.token
      )
    );
  };

  return (
    <div style={{ marginBottom: "2rem" }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Order Table
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={8}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="order status tabs"
          >
            <Tab label="All" value="All" />
            <Tab label="Processing" value="processing" />
            <Tab label="Ready to pick Up" value="processed" />
            <Tab label="Picked Up" value="delivered" />
          </Tabs>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              mt: { xs: 2, sm: 0 },
            }}
          >
            <Autocomplete
              freeSolo
              options={tagOptions}
              value={tag}
              onInputChange={(event, newValue) => {
                setTag(newValue);
              }}
              onChange={(event, newValue) => {
                setTag(newValue || "");
                setPage(1);
                dispatch(
                  fetchOrders(
                    {
                      page: 1,
                      limit,
                      status: tabValue,
                      tag: newValue || "",
                      dealerId: dealerInfo._id,
                    },
                    dealerInfo.token
                  )
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search by Tag"
                  variant="outlined"
                  size="small"
                  sx={{ width: "100%" }} 
                />
              )}
              sx={{ width: { xs: "100%", sm: "300px" }, maxWidth: "100%" }} 
            />
            {/* <Button
              variant="contained"
              onClick={() =>
                dispatch(
                  fetchOrders(
                    {
                      page,
                      limit,
                      status: tabValue,
                      tag,
                      dealerId: dealerInfo._id,
                    },
                    dealerInfo.token
                  )
                )
              }
              sx={{ mt: 2 }}
            >
              Search
            </Button> */}
          </Box>
        </Grid>
      </Grid>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ height: "200px" }}
        >
          <CircularProgress color="secondary" />
        </Box>
      ) : (
        <>
          <OrderList
            orders={orders}
            orderBy={orderBy}
            order={order}
            onRequestSort={handleRequestSort}
          />
          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              Previous
            </Button>
            <Button
              variant="contained"
              onClick={() => handlePageChange(page + 1)}
              disabled={orders.length < limit}
            >
              Next
            </Button>
          </Box>
        </>
      )}
    </div>
  );
};

export default OrderLists;
